exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-publication-template-js": () => import("./../../../src/templates/publicationTemplate.js" /* webpackChunkName: "component---src-templates-publication-template-js" */),
  "component---src-templates-work-template-js": () => import("./../../../src/templates/workTemplate.js" /* webpackChunkName: "component---src-templates-work-template-js" */)
}

